import { Button, Divider, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Error500Page(props) {
  return (
    <Paper sx={{ textAlign: "center", pt: 5, px: 4, minHeight: 800 }}>
      <Typography sx={{ fontSize: "5em" }} color='primary'>
        Internal Server Error
      </Typography>
      <Divider />
      <Typography variant='h5' sx={{ marginTop: 5 }}>
        Oops! It seems there was an issue that caused the application to fail.{" "}
        <br />
        We have notified the administrator.
      </Typography>
      <br />
      <br />
      <Link to='/edit'>
        <Button variant='contained' size='large'>
          Back to Home
        </Button>
      </Link>
    </Paper>
  );
}
